import { render, staticRenderFns } from "./ScoreEditor.vue?vue&type=template&id=21da28e0"
import script from "./ScoreEditor.vue?vue&type=script&lang=js"
export * from "./ScoreEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports